import {GET_CYCLE_START} from "../../types";

export const cycle = (payload) => ({
    type: GET_CYCLE_START,
    payload,
});
